import {Observable} from 'rxjs';
import {QuoteModel} from './model';
import {SessionModel} from '../session/model';
import {Http} from '../../core/http';
import {QuoteApi} from './quote.api';
import {share} from 'rxjs/operators';

let fetchQuote$: Observable<QuoteModel> | null;

const fetchQuote = (sessionId: SessionModel['sessionId']) => {
  if (!fetchQuote$) {
    fetchQuote$ = Http.get<QuoteModel>(QuoteApi.get(sessionId)).pipe(share());
  }

  return fetchQuote$;
};

const resetCacheFetchQuote = () => fetchQuote$ = null;

export const QuoteHelperService = {fetchQuote, resetCacheFetchQuote};
